/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SEARCH_FILTER_HELPERS
 * Date:         2025-01-01
 * Modified By:  Cursor
 *
 * Description:
 * Filter helper functions for broadcast items.
 *
 * File Size Check:
 * - Current: 236 lines
 * - Replacing with: ~100 lines
 * - Projected: 100 lines
 * - Decision: Proceed (under 150 line limit for utilities)
 */

import { FlattenedBroadcastItem } from "../../broadcast/BroadcastItemCard";

interface BroadcastFilters {
  keyword?: string;
  sku?: string;
  type?: string;
  manufacturer?: string;
  category?: string;
  qty?: number;
  condition?: string;
  country?: string;
  company?: string;
}

/**
 * Applies filters to a list of flattened broadcast items.
 * [2025-01-01] Extracted from hook to standalone utility for pagination.
 */
export function applyBroadcastFilters(
  items: FlattenedBroadcastItem[],
  filters: BroadcastFilters
): FlattenedBroadcastItem[] {
  return items.filter(item => {
    // [2025-01-01] Filter by keyword
    if (filters.keyword) {
      const keyword = filters.keyword.toLowerCase();
      const searchableText = [
        item.title,
        item.manufacturer,
        item.model,
        item.partNumber,
        item.description,
      ].filter(Boolean).join(" ").toLowerCase();
      
      if (!searchableText.includes(keyword)) return false;
    }

    // [2025-01-01] Filter by SKU/part number
    if (filters.sku && filters.sku !== "All") {
      if (item.partNumber !== filters.sku) return false;
    }

    // [2025-01-01] Filter by type (WTB/WTS)
    if (filters.type && filters.type !== "All") {
      if (item.broadcastGroup?.type !== filters.type) return false;
    }

    // [2025-01-01] Filter by manufacturer
    if (filters.manufacturer && filters.manufacturer !== "All Manufacturers") {
      if (item.manufacturer !== filters.manufacturer) return false;
    }

    // [2025-01-01] Filter by category
    if (filters.category && filters.category !== "All Categories") {
      if (!item.categories?.includes(filters.category)) return false;
    }

    // [2025-01-01] Filter by quantity
    if (filters.qty && filters.qty > 0) {
      if (!item.quantity || item.quantity < filters.qty) return false;
    }

    // [2025-01-01] Filter by condition
    if (filters.condition && filters.condition !== "All") {
      if (item.condition !== filters.condition) return false;
    }

    // [2025-01-01] Filter by country
    if (filters.country && filters.country !== "All") {
      if (item.country !== filters.country) return false;
    }

    // [2025-01-01] Filter by company
    if (filters.company && filters.company !== "Company") {
      const companyName = typeof item.broadcastGroup?.userId === "object" 
        ? (item.broadcastGroup.userId as any).companyName 
        : "";
      if (companyName !== filters.company) return false;
    }

    return true;
  });
}
